import React from 'react';
import * as S from './style';

export type TSize = 'XS' | 'S' | 'L' | 'XL';

interface Props {
    background?: string;
    size?: TSize;
    icon?: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

function ProfileImage({ background, size, icon, onClick }: Props): React.ReactElement {
    return (
        <S.ProfileImage size={size} background={background} onClick={onClick}>
            {onClick ? icon : null}
        </S.ProfileImage>
    );
}

export default ProfileImage;
